module.exports = __webpack_public_path__ + "front/img/15.ac208daa.jpg";